import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios'
import './Courses.css'
import BookImg from '../../images/BookImg.png'
import WarningImg from '../../images/warning.svg'
import Lock from '../../images/lock.svg'

import Animation from '../../images/Animation2.gif'
import "remixicon/fonts/remixicon.css";
import { useNavigate, useParams } from 'react-router-dom';
import Contents from './components/contents';

import { API, formatNumber } from '../../constants';
import { toast } from "react-toastify";
import res from "html2pdf.js";
import api from '../../Components/RefreshToken/RefreshToken';
import { useTranslation } from 'react-i18next';

const Lessons = (props) => {
    const { courseId } = useParams();
    const { t } = useTranslation();

    const [playLesson, setPlayLesson] = useState(false)
    const chatBodyRef = useRef(null)
    const [hiddenChat, setHiddenChat] = useState(false);
    const [courses, setCourses] = useState([]);
    const [course, setCourse] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [coursesPerPage, setCoursesPerPage] = useState(8)
    const totalPages = Math.ceil(courses.length / coursesPerPage);
    const [randomCourse, setRandomCourse] = useState([])
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate();

    const goToCourse = () => {
        const token = localStorage.getItem('token');

        if (token) {
            try {
                api.post(`${API}/student/enroll?course_id=${courseId}`, {}, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }).then((res) => {
                    toast.success(t("enrolledSuccess"));
                    navigate(`/student/courses/${res?.data?.id}`);

                }).catch((err) => {
                    if (err.response?.status === 409) {
                        toast.success(t("alreadyEnrolled"));
                        navigate(`/student/courses`);
                    }

                    if (err.response?.status === 403) {
                        toast.warning(t("firstLogin"));
                    }
                })
            } catch (err) {
                toast.error(t("errorOccured"))
            }
        } else {
            toast.error(t("loginFirst"))
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const hideChatHandle = () => {
        setHiddenChat(true);
    };

    const handlePlayClick = (courseId) => {
        navigate(`/courses/${courseId}`);
    };

    useEffect(() => {
        setLoading(true)
        if (!!props?.courseId || !!courseId) {
            api.get(`${API}/courses/public/detail/${props?.courseId || courseId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }).then((response) => {
                setCourse(response.data);
            }).catch((error) => {
                toast.error(`${t("errorFetchingCourses")}: ${error?.message || t("unknownError")}`);
            }).finally(() => {
                setLoading(false)
            })

        }
        const handleResize = () => {
            if (window.innerWidth <= 550) {
                setCoursesPerPage(4);
            } else {
                setCoursesPerPage(8);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [courseId]);

    const currentCourses = courses.slice(
        (currentPage - 1) * coursesPerPage,
        currentPage * coursesPerPage
    );

    const [messages, setMessages] = useState([
        { text: t("helpBotWelcome"), sender: "bot", time: "12:55 am" },
    ]);

    const [inputMessage, setInputMessage] = useState([]);
    const [input, setInput] = useState("");

    useEffect(() => {
        if (chatBodyRef.current) {
            chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
        }
    }, [messages, inputMessage]);

    useEffect(() => {
        api.get(`${API}/courses/`)
            .then((response) => {
                const allCourses = response.data;
                const shuffled = allCourses.sort(() => 0.5 - Math.random());
                const selected = shuffled.slice(0, 2);

                setRandomCourse(selected);
            })
            .catch((error) => {
                console.error(t("errorFetchingCourses"), error);
            });
    }, [courseId]);

    return (
        <>
            <div className="container">
                <h3 className="detail-title">{t("detailTitle")}</h3>
                <div className="detail-box">
                    <div className="detail-left">
                        <img src={`${API}/${course?.photo}`} alt="course image" />
                        <h3 className="numbers-title">{course?.title}</h3>
                        <p className="detail-course-info">{t("detailCourseInfo")}</p>
                        <div className="numbers">
                            <div className="numbers-info">
                                <h5 className="numbers-title">{t("byTheNumbers")}</h5>
                                <div className="numbers-text-box">
                                    <i className="ri-check-double-line numbers-icon"></i>
                                    <span className="numbers-text">{t("skillLevel")}</span>
                                </div>
                                <div className="numbers-text-box">
                                    <i className="ri-user-3-line numbers-icon"></i>
                                    <span className="numbers-text">{t("studentsCount", { count: 38815 })}</span>
                                </div>
                                <div className="numbers-text-box">
                                    <i className="ri-flag-line numbers-icon"></i>
                                    <span className="numbers-text">{t("languages")}: {course?.language}</span>
                                </div>
                                <div className="numbers-text-box">
                                    <i className="ri-article-line numbers-icon"></i>
                                    <span className="numbers-text">{t("captions")}</span>
                                </div>
                            </div>
                            <div className="detail-description">
                                <h4 className="numbers-title">{t("description")}</h4>
                                <p className="detail-desc" dangerouslySetInnerHTML={{ __html: course?.description }}></p>
                            </div>
                            <div className="instructor-block">
                                <h4 className="numbers-title">{t("instructor")}</h4>
                                <div className="detail-teacher">
                                    <i className="ri-user-2-fill teacher-icon"></i>
                                    <div className="teacher-text">
                                        <h5 className="teacher-name">{t("teacherName")}</h5>
                                        <p className="teacher-role">{t("student3Role")}</p>
                                    </div>
                                    {!!!props?.courseId ? <button onClick={goToCourse} className="button play-btn detail-button">
                                        {t('continueBtn')}
                                    </button> : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="detail-right">
                        {randomCourse?.map((item, index) => (
                            <div className="random-card" key={item.id}>
                                <img src={`${API}/${item.photo}`} alt="image" className="random-img" />
                                <h4 className="random-title">{item.title}</h4>
                                <h4 className="random-title">{formatNumber(item.price)} {t('price')}</h4>
                                <p className="random-mentor">{item?.mentor?.first_name} {item?.mentor?.last_name}</p>
                                <button onClick={() => handlePlayClick(item?.id)} className="random-btn">{t("detail")} <i className=" ri-checkbox-circle-line detail-icon"></i></button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {loading && (
                <div className="loading">
                    <img src={Animation} alt="imagte" />
                </div>
            )}
        </>
    )
}

export default Lessons;